export default __webpack_public_path__ + "static/media/amms-graph-gc.c9b8838d.svg";